import styled from 'styled-components';

const Loading = () => {
  return (
    <LoadingWrapper>
      <div className="loading-circle-wrapper">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>
    </LoadingWrapper>
  );
};

export default Loading;

const LoadingWrapper = styled.div`
  background-color: #fff;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .loading-circle-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    .circle {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      background-color: #040c4b;
      animation: loading 2s ease forwards infinite;
      opacity: 0;
      &.circle-2 {
        animation-delay: 0.3s;
      }
      &.circle-3 {
        animation-delay: 0.6s;
      }
    }
  }
  @keyframes loading {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0);
      opacity: 0;
    }
  }
`;
